jQuery(function ($) {
    // どちらのルートでも使う
    var ROOT_SELECTORS = ['.p-oem__sec07', '.p-contact__qa'];

    var $roots = $(ROOT_SELECTORS.join(','));
    if (!$roots.length) return;

    $roots.each(function () {
        var $root = $(this);
        var $toggles = $root.find('.js-accordion-toggle');

        if (!$toggles.length) return;

        // 初期は閉じ
        $root.find('.js-accordion-panel').hide();
        $toggles
            .attr('aria-expanded', 'false')
            .find('.p-oem__sec07__mark, .p-contact__qa__mark, .js-accordion-mark')
            .text('+');

        $toggles.on('click', function () {
            var $btn = $(this);
            var $item = $btn.closest('.js-accordion-item');
            var $panel = $item.find('.js-accordion-panel').first();
            var $mark = $btn.find('.p-oem__sec07__mark, .p-contact__qa__mark, .js-accordion-mark');

            var isOpen = $btn.attr('aria-expanded') === 'true';

            if (isOpen) {
                // close
                $btn.attr('aria-expanded', 'false');
                $panel.stop(true, true).slideUp(220);
                $mark.text('+');
                $item.removeClass('is-open');
            } else {
                // open
                $btn.attr('aria-expanded', 'true');
                $panel.stop(true, true).slideDown(220);
                $mark.text('−');
                $item.addClass('is-open');
            }
        });
    });
});
